import { isAfter, isBefore, isValid } from "date-fns";

export enum DATE_ERROR {
    REQUIRED = "REQUIRED",
    INVALID = "INVALID",
    FORMAT_ERROR = "FORMAT_ERROR",
    INF_TO_MIN_DATE = "INF_TO_MIN_DATE",
    MAX_TO_MAX_DATE = "MAX_TO_MAX_DATE"
}

export const validateDate = (date: any, min_date?: Date | null, max_date?: Date | null): DATE_ERROR[] => {
    const errors = [];
    if (!date) {
        errors.push(DATE_ERROR.REQUIRED);
    }
    if (date && !isValid(date)) {
        errors.push(DATE_ERROR.INVALID);
    }
    const control = date && isValid(date);
    if (control && (date?.getFullYear() ?? 0) < 1000) {
        errors.push(DATE_ERROR.FORMAT_ERROR);
    }
    if (control && min_date && isValid(min_date) && isBefore(date as Date, min_date)) {
        errors.push(DATE_ERROR.INF_TO_MIN_DATE);
    }
    if (control && max_date && isValid(max_date) && isAfter(date as Date, max_date)) {
        errors.push(DATE_ERROR.MAX_TO_MAX_DATE);
    }
    return errors;
};